module.exports = __webpack_public_path__ + "img/courier_2.ea52b9b1.png";